<template>
  <div class="app-container xmzk_z">
    <div>
      <el-button type="text" @click="$router.back()" icon="el-icon-back"
        >返回</el-button
      >
    </div>
    <div class="card">
      <div class="card-header">
        <div class="card-title"><div>文件上传</div></div>
      </div>
      <div>
        <div class="content">
          <div class="steps">
            <el-steps :active="step" align-center>
              <el-step title="文件上传" description="请上传指定文件"></el-step>
              <el-step
                title="数据校验"
                description="检测数据格式是否正确"
              ></el-step>
              <el-step title="完成"></el-step>
            </el-steps>
          </div>
          <div class="line"></div>
          <div class="menu">
            <div class="download">
              <el-button size="small" type="primary" @click="downloadFile()"
                >下载模板</el-button
              >
              <div class="tips">点击下载模板，并按照规定格式填写数据</div>
            </div>
            <div class="upload">
              <el-upload
                class="upload"
                ref="upload"
                action="#"
                :on-exceed="handleExceed"
                :on-change="handleChange"
                :file-list="fileList"
                :show-file-list="false"
                :headers="headers"
                :auto-upload="false"
                multiple
                :limit="1"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  上传文件格式仅支持xls、xlsx，文件大小不超过10M，并且只支持单个文件上传
                </div>
              </el-upload>
            </div>
          </div>
          <div class="success" v-if="scqk === 1">
            <div>
              <el-tabs v-model="activeName" @tab-click="handleClickTabs">
                <el-tab-pane label="年度指标" name="nd"> </el-tab-pane>
                <el-tab-pane label="半年度指标" name="bnd"></el-tab-pane>
                <el-tab-pane label="季度指标" name="jd"></el-tab-pane>
              </el-tabs>
              <div>
                <el-table
                  :data="successTableList"
                  fit
                  highlight-current-row
                  :default-sort="{ prop: 'date', order: 'descending' }"
                  tooltip-effect="dark"
                  border
                  :header-cell-style="tableHeaderColor"
                >
                  <el-table-column
                    label="所属部门"
                    align="center"
                    prop="bmmc"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="项目名称"
                    align="center"
                    prop="xmmc"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="指标名称"
                    align="center"
                    prop="zbmc"
                    :show-overflow-tooltip="true"
                  />
                  <!-- <el-table-column
                    label="时间频率"
                    align="center"
                    prop="sjpl"
                    :show-overflow-tooltip="true"
                  /> -->
                  <el-table-column
                    label="导入结果"
                    align="center"
                    prop="drjg"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="原结果"
                    align="center"
                    prop="yjg"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="导入类型"
                    align="center"
                    prop="drlx"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="导入时间"
                    align="center"
                    prop="createTime"
                    :show-overflow-tooltip="true"
                  />
                  <el-table-column
                    label="操作人"
                    align="center"
                    prop="createBy"
                    :show-overflow-tooltip="true"
                  />
                  <template slot="empty">
                    <div class="nodata">
                      <img src="@/img/nodata.png" alt="" width="160" />
                      <div>暂无数据</div>
                    </div>
                  </template>
                </el-table>
              </div>
            </div>
          </div>
          <div class="fail" v-if="scqk === 0">
            <div class="fail-hearder">
              <div class="export-btn">
                <el-button
                  size="small"
                  type="primary"
                  @click="handleExportError"
                  >导出数据</el-button
                >
              </div>
              <div class="fail-msg">
                <div>
                  <i
                    class="el-icon-error"
                    style="color: #ee4e4e; font-size: 16px"
                  ></i>
                  数据校验
                </div>
                <div class="msg">
                  本次上传文件共有{{ fail.info.zs }}条数据，其中检验正确{{
                    fail.info.zq
                  }}条，{{ fail.info.cw }}条数据错误，错误数据如下：
                </div>
              </div>
            </div>
            <div>
              <el-table
                :data="failTableList"
                fit
                highlight-current-row
                :default-sort="{ prop: 'date', order: 'descending' }"
                tooltip-effect="dark"
                border
                :header-cell-style="tableHeaderColor"
              >
                <el-table-column
                  label="错误原因"
                  align="center"
                  prop="result"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="所属部门"
                  align="center"
                  prop="bmmc"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="项目名称"
                  align="center"
                  prop="xmmc"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="指标名称"
                  align="center"
                  prop="zbmc"
                  :show-overflow-tooltip="true"
                />
                <!-- <el-table-column
                  label="时间频率"
                  align="center"
                  prop="sjpl"
                  :show-overflow-tooltip="true"
                /> -->
                <el-table-column
                  label="导入结果"
                  align="center"
                  prop="drjg"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="原结果"
                  align="center"
                  prop="yjg"
                  :show-overflow-tooltip="true"
                />
                <!-- <el-table-column
                  label="导入类型"
                  align="center"
                  prop="drlx"
                  :show-overflow-tooltip="true"
                /> -->
                <el-table-column
                  label="导入时间"
                  align="center"
                  prop="createTime"
                  :show-overflow-tooltip="true"
                />
                <el-table-column
                  label="操作人"
                  align="center"
                  prop="createBy"
                  :show-overflow-tooltip="true"
                />
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
            </div>
          </div>
          <div class="footer">
            <el-button
              size="small"
              type="primary"
              @click="importData"
              v-if="scqk == 1"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { zbUpload, exportErrorList, importZbjg } from "@/api/xmzk.js";
import { getDict } from "@/api/common.js";
import axios from "axios";
export default {
  computed: {
    ...mapGetters([]),
  },
  data() {
    return {
      action: window.g.apiUrl + "zkgl/import/upload",
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      scqk: null,
      success: {},
      successTableList: [],
      fail: {},
      failTableList: [],
      activeName: "nd",
      step: 0,
      fileList: [],
      fileUrl: null,
    };
  },
  created() {
    getDict("pmp_zxlc_template_url", 1).then((res) => {
      if (res.code == 0) {
        for (let i of res.data) {
          if (i.dictValue == 3) {
            this.fileUrl = i.dictLabel;
          }
        }
      }
    });
  },
  methods: {
    handleChange(file, fileList) {
      const suffixReg = /(xls|xlsx)$/;
      const point = file.name.lastIndexOf(".");
      const suffix = file.name.substr(point + 1);
      const isFile = suffixReg.test(suffix);
      if (!isFile) {
        this.$message.error("请上传正确格式的文件 !");
        fileList.pop();
        return false;
      }

      // 验证文件大小
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
      //   this.$refs.upload.submit();
      let { uploadFiles } = this.$refs.upload;
      let form = new FormData();
      uploadFiles.forEach((item, index) => {
        form.append("file", item.raw);
      });
      this.step = 1;
      zbUpload(form).then((res) => {
        if (res.code == 0) {
          this.$message.success("上传成功！");
          this.scqk = res.data.scqk;
          this.step = 2;
          this.fileList = [];
          if (res.data.scqk == 1) {
            this.success = res.data;
            this.successTableList = this.success.ndzb;
          } else {
            this.fail = res.data;
            this.failTableList = this.fail.zbjgList;
          }
        } else {
          this.fileList = [];
          this.$message({
            type: "error",
            message: res.msg,
            showClose: true,
          });
        }
      });
    },

    downloadFile() {
      const filePath = this.fileUrl;
      // const
      const len = filePath.split("/").length;
      const fileName = filePath.split("/")[len - 1];
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleClickTabs(e) {
      if (e.name == "nd") {
        this.successTableList = this.success.ndzb;
      } else if (e.name == "bnd") {
        this.successTableList = this.success.bndzb;
      } else {
        this.successTableList = this.success.jdzb;
      }
    },
    handleExportError() {
      exportErrorList().then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    importData() {
      importZbjg().then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.fileList = [];
          this.scqk = null;
          this.activeName = "nd";
          this.step = 3;
          setTimeout(() => {
            this.step = 0;
          }, 3000);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.app-container {
  min-height: 100%;
  min-width: 1200px;
  background-color: #eef2f8;
  padding: 10px;
  font-family: "Arial Negreta" !important;
  box-sizing: border-box;
}

.card1 {
  .content {
    padding: 15px 15px 0 15px;

    > div {
      margin-bottom: 15px;
    }
  }
}
.card {
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  margin: 15px 0;
  .card-header {
    display: flex;
    justify-content: space-between;
    height: 22px;
    line-height: 22px;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;
    .card-title {
      position: relative;
      font-size: 16px;
      font-weight: 700;
      > div {
        padding-left: 15px;
      }
    }
    .card-title::before {
      content: "";
      height: 100%;
      background: #036eb8;
      width: 4px;
      position: absolute;
      border-radius: 4px;
    }
    .card-more {
      color: #999;
      font-size: 13px;
      cursor: pointer;
    }
  }
}
.steps {
  padding: 20px;
}
.menu {
  display: flex;
  justify-content: space-around;
  text-align: center;
  .tips {
    font-size: 12px;
    color: #606266;
    margin-top: 7px;
  }
}
.success,
.fail {
  padding: 20px;
}
.fail {
  .fail-hearder {
    display: flex;
  }
  .export-btn {
    height: 50px;
    line-height: 50px;
    width: 120px;
  }
  .fail-msg {
    width: calc(100% - 120px);
    display: flex;
    background-color: #fdecea;
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    padding: 0 15px;
    font-weight: bold;
    color: #333;
    font-size: 14px;
    .msg {
      color: #888;
      font-size: 12px;
      margin-left: 15px;
    }
  }
}
.footer {
  display: flex;
  margin-top: 15px;
  justify-content: center;
}
</style>
